<template>
  <div
    class="info-panel"
    :style="{
      paddingTop:`${padding}px`,
      paddingBottom:`${padding}px`}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'InfoPanel',
  props: {
    padding: {
      default: 16,
      type: Number,
    },
  },
};
</script>
<style lang="scss" scoped>
.info-panel {
  background: rgba($--base-color-grey-light-2, 1);
  padding-left: 16px;
  padding-right: 16px;
}
</style>
